export class AssociatedSymptom {
  private static _values: AssociatedSymptom[] = [];
  private static _lookup: Map<number, AssociatedSymptom> = new Map();

  static fromId(id: number) {
    const instance = AssociatedSymptom._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid AssociatedSymptom.id: ' + id);
    }
    return instance;
  }

  static values(): AssociatedSymptom[] {
    return [...AssociatedSymptom._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    AssociatedSymptom._values.push(this);
    AssociatedSymptom._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<AssociatedSymptom: ' + this.id + ", label='" + this.label + "'>";
  }
}
